export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};


//////////////////
// WEBPACK FOOTER
// ../~/rc-calendar/es/date/DateConstants.js
// module id = 727
// module chunks = 1